import gql from 'graphql-tag';

export const setNewsletterIssueStatusMutation = gql`
    mutation setNewsletterIssueStatusMutation($id: ID!, $status: NewsStatus!) {
        results: newsletterIssueSetStatus(id: $id, newStatus: $status) {
            id
            status
        }
    }
`;